
import React, {Component} from 'react'
import getWeb3 from './utils/getWeb3'
import Web3 from 'web3'
import _ from 'lodash';
import variablestore from './variablestore'

import {Link} from "react-router"
import NavLink from './NavLink'

import cross from '../img/cross.jpg'
import tick from '../img/tick.jpg'
const blockies = require('ethereum-blockies-png')

const gasLimit = 300000
class RegisterSellerRS extends Component {
	
		constructor(props){
			super(props)
			
			// eslint-disable-next-line no-undef
			var ETH_CLIENT = new Web3(web3.currentProvider)
			var EscrowMyEtherEntityDB_ABI = variablestore.EscrowMyEtherEntityDB_ABI
			var EscrowMyEtherEntityDB_address = variablestore.EscrowMyEtherEntityDB_address
			var myetherescrowABI = variablestore.myetherescrowABI
			var myetherescrowAddress = variablestore.myetherescrowAddress


			this.state = {

				ETH_CLIENT: ETH_CLIENT,
				mee: ETH_CLIENT.eth.contract(myetherescrowABI).at(myetherescrowAddress),
				entitydb: ETH_CLIENT.eth.contract(EscrowMyEtherEntityDB_ABI).at(EscrowMyEtherEntityDB_address),
				accounts: ETH_CLIENT.eth.accounts,
				fromAddress: "",

			
			
				withdrawText: "Withdraw Funds",
				profileText: "Update Profile",
			
				sellerName: "",
				sellerInfo: "",
				balance: 0,
				addressBalance: 0,
				callback: "",
				popup: false,
				addressBlockie: "",
				name: "",
				info: ""
			
			}



			this.generateTransaction = this.generateTransaction.bind(this);
			
      		this.handleNameInput = this.handleNameInput.bind(this);
			this.handleInfoInput = this.handleInfoInput.bind(this);

			this.resetButtonText = this.resetButtonText.bind(this);
	
		}

		closePopup() {
			this.setState({				
				popup: false			
			});

		}

		clearState() {
			this.resetButtonText()
			this.setState({				
				popup: false,
				addressBalance: 0,
				balance: 0,
				tableRows: [],
				sellerName: "",
				sellerInfo: "",
				addressBlockie: "",
				fromAddress: ""

			});

		}




		resetButtonText(){
			this.setState({
		
				withdrawText: "Withdraw Funds"
				
			});

		}

		


	
    
  
    handleNameInput(e) {
      this.setState({name: e.target.value});
    }
    handleInfoInput(e) {
      this.setState({info: e.target.value});
    }
  
  
    handleGasInput(e) {
      this.setState({gasLimit: e.target.value});
    }
  
  
    generateTransaction(){
      this.state.entitydb.registerSeller(this.state.name,this.state.info, {from: this.props.fromAddress, gas: gasLimit}, function(error, result){
				if(!error)
					{
						this.props.newTxCallback(result)		
					}	
				else
					
					console.log(error)

			}.bind(this))

    }
  


		
  render() {

	
	
	
    return (
    
      
  
		
		<div>
			
		<h2>Update Seller Profile</h2>
		<p className="align-left">
      Your Seller name will appear when Buyers are creating new transactions to your address and in their purchase history. 
      
                <br/>
                </p>
								<table>
								<tr>
														<td><p className="left">Your Address: {this.props.fromAddress}</p></td>
														
													
														
													</tr>
                          <tr>
                          <td><p className="left">Name:</p></td>
              
                          
                        </tr>
                        <tr>
                          <td><input className="left input-address input-pad" type="text" placeholder="" onChange={this.handleNameInput} value={this.state.name}/></td>
                          
                        </tr>
              
                        <tr>
                          <td><p className="left">Info:</p></td>
                         
                        </tr>
                        <tr>
                          <td><input className="left input-address input-pad" type="text" placeholder="" onChange={this.handleInfoInput} value={this.state.info}/></td>
                        </tr>
								
													
												
								
												 
													<tr>
													<td colSpan="2"><br/><button className="mainButton" onClick={this.generateTransaction}><h2>{this.state.profileText}</h2></button><br/><br/></td>
													</tr>
													</table>
		
		</div>


    )
  }
}

export default RegisterSellerRS;



// WEBPACK FOOTER //
// ./src/RegisterSellerRS.js